// Finds things in a task's text that a driver would want to tap: web links and
// Norwegian mobile numbers (8 digits, optional +47). Used for the buttons under a task.

export type TaskLink = { kind: "url"; href: string; label: string } | { kind: "phone"; href: string; label: string };

const URL_RE = /\b(?:https?:\/\/|www\.)[^\s<>"']+/gi;
// 8 digits in a row, optionally prefixed with +47 / 0047; not part of a longer number.
const PHONE_RE = /(?<![\d+])(?:(?:\+|00)47\s?)?\d{8}(?!\d)/g;

export function extractLinks(text: string): TaskLink[] {
  const links: TaskLink[] = [];
  const seen = new Set<string>();
  const add = (link: TaskLink) => {
    if (seen.has(link.href)) return;
    seen.add(link.href);
    links.push(link);
  };

  for (const match of text.match(URL_RE) ?? []) {
    const raw = match.replace(/[.,;:!?)\]]+$/, ""); // trailing punctuation belongs to the sentence
    const href = /^https?:\/\//i.test(raw) ? raw : `https://${raw}`;
    let label = raw.replace(/^https?:\/\//i, "").replace(/^www\./i, "");
    label = label.split(/[/?#]/)[0] || label;
    add({ kind: "url", href, label });
  }

  // Blank out the URLs so digits inside them don't get read as phone numbers.
  const withoutUrls = text.replace(URL_RE, " ");
  for (const match of withoutUrls.match(PHONE_RE) ?? []) {
    const digits = match.replace(/\D/g, "").replace(/^0047/, "47").replace(/^47(?=\d{8}$)/, "");
    add({ kind: "phone", href: `tel:+47${digits}`, label: digits });
  }
  return links;
}
